module.exports = __webpack_public_path__ + "img/025-copyright.5fa4116a.svg";